import defaultTheme from './defaultTheme';
const synchronyTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#232f3e', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#232f3e', background: '#232f3e' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#232f3e' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#232f3e', border: '#232f3e', background: '#232f3e' }), field: {
        focus: '#232f3e',
        label: '#232f3e',
        icon: '#232f3e',
    } });
export default synchronyTheme;
